import React from 'react';
import { BeakerIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { UserInfo } from '../../services/authService';

interface HeaderProps {
  user: UserInfo | null;
  userType: string | null;
  onLogout: () => void;
}

export const Header: React.FC<HeaderProps> = ({ user, userType, onLogout }) => (
  <header className="bg-white border-b border-slate-200">
    <div className="w-full px-4 sm:px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2.5">
        <span className="flex items-center justify-center h-9 w-9 rounded-md bg-brand-700 text-white">
          <BeakerIcon className="h-5 w-5" />
        </span>
        <div className="leading-tight">
          <p className="text-base font-semibold text-slate-900">NEA Panel</p>
          <p className="text-xs text-slate-500">Gestión de análisis de laboratorio</p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {user && (
          <div className="hidden sm:flex flex-col items-end leading-tight">
            <span className="text-sm font-medium text-slate-700">{user.nombre}</span>
            <span className="text-xs text-slate-400 capitalize">{userType || 'Usuario'}</span>
          </div>
        )}
        <button
          onClick={onLogout}
          className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-slate-600 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
        >
          <ArrowRightOnRectangleIcon className="h-4 w-4" />
          Cerrar sesión
        </button>
      </div>
    </div>
  </header>
);

export default Header;
